import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "time",
  "use": "time-usage",
  "viewBox": "0 0 66.5 66.5",
  "content": "<symbol viewBox=\"0 0 66.5 66.5\" id=\"time\"><title>资源 93</title><g id=\"time_图层_2\" data-name=\"图层 2\"><g id=\"time_图层_1-2\" data-name=\"图层 1\"><path d=\"M32.46,38.6a3.74,3.74,0,0,0,1.11.81l11.49,7a3,3,0,0,0,1.48.42,2.58,2.58,0,0,0,.75-.11A3,3,0,0,0,49,45.23,3.16,3.16,0,0,0,47.66,41l-11.2-6.47V16.8a3.1,3.1,0,0,0-6.19,0V36C30.26,36.88,31,37.75,32.46,38.6Z\" /><path d=\"M56.78,9.73a33.26,33.26,0,0,0-47,47,33.26,33.26,0,0,0,47-47ZM33.26,5a28.24,28.24,0,1,1-20,8.26A28.1,28.1,0,0,1,33.26,5Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/time.svg
// module id = vsvj
// module chunks = 264